import './services.css';

import ServiceCard from 'components/service_card';
import { domain } from 'config';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getHomepage, getHomepageIdle } from 'store/ducks/homepage/actions';
import { getServices, getServicesIdle } from 'store/ducks/services/actions';
import { StateStatus } from 'types/models';
import { Helmet } from 'react-helmet';

type Props = {};

const Services = (props: Props) => {
    const dispatch = useDispatch();

    const { status, data }: any = useSelector(
        (state: { services: any }) => state.services
    );

    useEffect(() => {
        if (status == 'SUCCESS') {
            if (typeof window !== 'undefined') {
                if (window.location.hash) {
                    window.scrollTo({
                        top:
                            document
                                .querySelector(window.location.hash)
                                .getBoundingClientRect().top + window.scrollY,
                        behavior: 'smooth',
                    });
                }
            }
            if (
                typeof window !== undefined &&
                typeof window.Swiper !== undefined
            ) {
                // window.addEventListener('load', function(){
                new window.Swiper('.swiper', {
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 8,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                // })
            }

            // dispatch(getServicesIdle());
        }
    }, [status]);

    useEffect(() => {
        if (status == 'IDLE') {
            dispatch(getServices());
        }
    }, []);

    return (
        <>
            <Helmet>
                <meta
                    property="og:url"
                    content="https://normdubai.com/services/"
                />
                <title>Начать жить в Эмиратах</title>
                <meta
                    name="description"
                    content="Сокращаем процесс с месяцев до недели, снижаем вероятность отказа почти до ноля, делаем за вас всю бумажную работу"
                ></meta>
                <meta property="og:site_name" content="Нормальный Дубай" />
                <meta property="og:type" content="page" />
                <meta property="og:title" content="Начать жить в Эмиратах" />
                <meta
                    property="og:description"
                    content="Сокращаем процесс с месяцев до недели, снижаем вероятность отказа почти до ноля, делаем за вас всю бумажную работу"
                />
                <meta
                    property="og:image"
                    content="https://normdubai.com/assets/images/og.png"
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta
                    property="vk:image"
                    content="https://normdubai.com/assets/images/og.png"
                />
                <meta property="vk:image:width" content="537" />
                <meta property="vk:image:height" content="240" />
                <meta
                    property="twitter:image"
                    content="https://normdubai.com/assets/images/og.png"
                />
                <meta property="twitter:image:width" content="1024" />
                <meta property="twitter:image:height" content="512" />

                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>
            <div className="page _services">
                {data.map((category: any, category_index: any) => {
                    let grid_index_1 = 0;
                    let grid_index_2 = 0;
                    return (
                        <div
                            className="section _category"
                            id={`category-${category.id}`}
                            key={category.id}
                        >
                            <div className="container">
                                <div className="section__header">
                                    <div
                                        className="section__title"
                                        dangerouslySetInnerHTML={{
                                            __html: category.attributes.Title,
                                        }}
                                    ></div>
                                    <div className="section__description">
                                        <h4
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    category.attributes
                                                        .Description,
                                            }}
                                        ></h4>
                                    </div>
                                </div>
                                {category.attributes.Services.data &&
                                    category.attributes.Services.data.length >
                                        0 && (
                                        <>
                                            <div
                                                className={`section__grid category_${category.id}`}
                                            >
                                                <div className="grid">
                                                    {category.attributes.Services.data.map(
                                                        (
                                                            service_item: any,
                                                            service_index: any
                                                        ) => {
                                                            return (
                                                                <div
                                                                    key={
                                                                        service_item.id
                                                                    }
                                                                    className="grid__item"
                                                                >
                                                                    <ServiceCard
                                                                        linkType=""
                                                                        link={
                                                                            '/services/' +
                                                                            service_item
                                                                                .attributes
                                                                                .Slug
                                                                        }
                                                                        title={
                                                                            service_item
                                                                                .attributes
                                                                                .Title
                                                                        }
                                                                        image={
                                                                            domain +
                                                                            service_item
                                                                                .attributes
                                                                                .Preview
                                                                                .data
                                                                                .attributes
                                                                                .url
                                                                        }
                                                                    />
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                            <div className="section__slider">
                                                <div className="swiper">
                                                    <div className="swiper-wrapper">
                                                        {category.attributes.Services.data.map(
                                                            (
                                                                service_item: any,
                                                                service_index: any
                                                            ) => {
                                                                return (
                                                                    <div
                                                                        key={
                                                                            service_item.id
                                                                        }
                                                                        className="swiper-slide"
                                                                    >
                                                                        <ServiceCard
                                                                            link={
                                                                                '/services/' +
                                                                                service_item
                                                                                    .attributes
                                                                                    .Slug
                                                                            }
                                                                            title={
                                                                                service_item
                                                                                    .attributes
                                                                                    .Title
                                                                            }
                                                                            image={
                                                                                domain +
                                                                                service_item
                                                                                    .attributes
                                                                                    .Preview
                                                                                    .data
                                                                                    .attributes
                                                                                    .url
                                                                            }
                                                                        />
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                    <div className="swiper-pagination"></div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Services;
